/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

const React = require("react")
const { RootElement } = require('./src/components/root-element');
// import AppProvider from './src/context/AppProvider';
// import React from "react"
// import RootElement from "./src/components/root-element"

// export const wrapRootElement = ({ element }) => {
//     return <RootElement>{element}</RootElement>
// };

exports.wrapRootElement = ({ element }) => {
    return React.createElement(RootElement, null, element);
};